import { createReducer, on } from '@ngrx/store';
import { OrderDetailsActions } from '../actions';
import { RecreateCancelState } from '../order-details.state';

export const initialState: RecreateCancelState = {
  response: null,
  success: null,
  loading: null,
  error: null,
};

export const RecreateReducer = createReducer(
  initialState,
  on(
    OrderDetailsActions.recreateOrderDetails,
    (state) => {
      return ({
        ...state,
        loading: true,
        success: null,
        error: null,
      })
    }
  ),
  on(
    OrderDetailsActions.recreateOrderDetailsSuccess,
    (state, { response }) => {
      return ({
        ...state,
        response,
        loading: null,
        success: true,
        error: null,
      })
    }
  ),
  on(
    OrderDetailsActions.recreateOrderDetailsFail,
    (state, { payload }) => {
      return ({
        ...state,
        loading: null,
        success: null,
        error: payload,
      })
    }
  ),
  on(
    OrderDetailsActions.recreateOrderDetailsReset,
    () => ({ ...initialState })
  )
);
